var COLOR = {
  applegreen100: {
    name: 'applegreen100',
    color: '#edfaed'
  },
  applegreen200: {
    name: 'applegreen200',
    color: '#e0f4e0'
  },
  applegreen500: {
    name: 'applegreen500',
    color: '#0eb10b'
  },
  applegreen600: {
    name: 'applegreen600',
    color: '#059803'
  },
  black: {
    name: 'black',
    color: '#000000'
  },
  blackalpha05: {
    name: 'blackalpha05',
    color: 'rgba(#000000, 0.05)'
  },
  blackalpha10: {
    name: 'blackalpha10',
    color: 'rgba(#000000, 0.10)'
  },
  blackalpha15: {
    name: 'blackalpha15',
    color: 'rgba(#000000, 0.15)'
  },
  blackalpha20: {
    name: 'blackalpha20',
    color: 'rgba(#000000, 0.20)'
  },
  blackalpha50: {
    name: 'blackalpha50',
    color: 'rgba(#000000, 0.50)'
  },
  blackalpha60: {
    name: 'blackalpha60',
    color: 'rgba(#000000, 0.60)'
  },
  blue100: {
    name: 'blue100',
    color: '#f0faff'
  },
  blue200: {
    name: 'blue200',
    color: '#e6f2fb'
  },
  blue500: {
    name: 'blue500',
    color: '#0a7df3'
  },
  blue600: {
    name: 'blue600',
    color: '#026bd7'
  },
  brown100: {
    name: 'brown100',
    color: '#fdf6f3'
  },
  brown200: {
    name: 'brown200',
    color: '#faede9'
  },
  brown500: {
    name: 'brown500',
    color: '#a56e45'
  },
  brown600: {
    name: 'brown600',
    color: '#875733'
  },
  cyan100: {
    name: 'cyan100',
    color: '#eefcff'
  },
  cyan200: {
    name: 'cyan200',
    color: '#e1f6fc'
  },
  cyan500: {
    name: 'cyan500',
    color: '#009ac7'
  },
  cyan600: {
    name: 'cyan600',
    color: '#0088af'
  },
  darkgray200: {
    name: 'darkgray200',
    color: '#909aab'
  },
  darkgray300: {
    name: 'darkgray300',
    color: '#718095'
  },
  darkgray400: {
    name: 'darkgray400',
    color: '#475059'
  },
  darkgray500: {
    name: 'darkgray500',
    color: '#2e343a'
  },
  darkgray600: {
    name: 'darkgray600',
    color: '#24282c'
  },
  deeporange100: {
    name: 'deeporange100',
    color: '#ffeee9'
  },
  deeporange200: {
    name: 'deeporange200',
    color: '#fbe2d9'
  },
  deeporange500: {
    name: 'deeporange500',
    color: '#f16234'
  },
  deeporange600: {
    name: 'deeporange600',
    color: '#e44b1a'
  },
  deeppurple100: {
    name: 'deeppurple100',
    color: '#f8f5ff'
  },
  deeppurple200: {
    name: 'deeppurple200',
    color: '#efeafc'
  },
  deeppurple500: {
    name: 'deeppurple500',
    color: '#7a5eeb'
  },
  deeppurple600: {
    name: 'deeppurple600',
    color: '#6642cc'
  },
  forest100: {
    name: 'forest100',
    color: '#ebf8f4'
  },
  forest200: {
    name: 'forest200',
    color: '#d7f1e9'
  },
  forest500: {
    name: 'forest500',
    color: '#159f76'
  },
  forest600: {
    name: 'forest600',
    color: '#008b61'
  },
  gray100: {
    name: 'gray100',
    color: '#f6f8fa'
  },
  gray150: {
    name: 'gray150',
    color: '#f3f5f7'
  },
  gray200: {
    name: 'gray200',
    color: '#edeff2'
  },
  gray250: {
    name: 'gray250',
    color: '#dcdee0'
  },
  gray300: {
    name: 'gray300',
    color: '#c8cacc'
  },
  gray400: {
    name: 'gray400',
    color: '#bbbbbd'
  },
  gray500: {
    name: 'gray500',
    color: '#aaaaac'
  },
  gray600: {
    name: 'gray600',
    color: '#929294'
  },
  gray700: {
    name: 'gray700',
    color: '#767678'
  },
  gray800: {
    name: 'gray800',
    color: '#404048'
  },
  gray900: {
    name: 'gray900',
    color: '#1e1e23'
  },
  green100: {
    name: 'green100',
    color: '#eef9f3'
  },
  green200: {
    name: 'green200',
    color: '#e3f6ed'
  },
  green500: {
    name: 'green500',
    color: '#09aa5c'
  },
  green600: {
    name: 'green600',
    color: '#0b9552'
  },
  indigo100: {
    name: 'indigo100',
    color: '#f6f8ff'
  },
  indigo200: {
    name: 'indigo200',
    color: '#e9eeff'
  },
  indigo500: {
    name: 'indigo500',
    color: '#5877e5'
  },
  indigo600: {
    name: 'indigo600',
    color: '#3e61db'
  },
  lemonyellow100: {
    name: 'lemonyellow100',
    color: '#fffee5'
  },
  lemonyellow200: {
    name: 'lemonyellow200',
    color: '#fffcbe'
  },
  lemonyellow500: {
    name: 'lemonyellow500',
    color: '#fff737'
  },
  lemonyellow600: {
    name: 'lemonyellow600',
    color: '#f0e705'
  },
  lightblue100: {
    name: 'lightblue100',
    color: '#eff8ff'
  },
  lightblue200: {
    name: 'lightblue200',
    color: '#e5f3fe'
  },
  lightblue500: {
    name: 'lightblue500',
    color: '#139fee'
  },
  lightblue600: {
    name: 'lightblue600',
    color: '#058bd7'
  },
  navergreen: {
    name: 'navergreen',
    color: '#03c75a'
  },
  neongreen100: {
    name: 'neongreen100',
    color: '#ebfff0'
  },
  neongreen200: {
    name: 'neongreen200',
    color: '#c7ffd6'
  },
  neongreen500: {
    name: 'neongreen500',
    color: '#3ce085'
  },
  neongreen600: {
    name: 'neongreen600',
    color: '#18d46c'
  },
  npaygreen: {
    name: 'npaygreen',
    color: '#00de5a'
  },
  olive100: {
    name: 'olive100',
    color: '#f5f9f1'
  },
  olive200: {
    name: 'olive200',
    color: '#ecf3e3'
  },
  olive500: {
    name: 'olive500',
    color: '#63b100'
  },
  olive600: {
    name: 'olive600',
    color: '#519200'
  },
  orange100: {
    name: 'orange100',
    color: '#fff3e9'
  },
  orange200: {
    name: 'orange200',
    color: '#ffe2c8'
  },
  orange500: {
    name: 'orange500',
    color: '#fa8836'
  },
  orange600: {
    name: 'orange600',
    color: '#eb690c'
  },
  purple100: {
    name: 'purple100',
    color: '#fef5ff'
  },
  purple200: {
    name: 'purple200',
    color: '#fae9fd'
  },
  purple500: {
    name: 'purple500',
    color: '#c759d4'
  },
  purple600: {
    name: 'purple600',
    color: '#ae39c1'
  },
  red100: {
    name: 'red100',
    color: '#fff5f5'
  },
  red200: {
    name: 'red200',
    color: '#fbebeb'
  },
  red500: {
    name: 'red500',
    color: '#ff5252'
  },
  red600: {
    name: 'red600',
    color: '#ed3738'
  },
  saddlebrown100: {
    name: 'saddlebrown100',
    color: '#fff8f5'
  },
  saddlebrown200: {
    name: 'saddlebrown200',
    color: '#faeee9'
  },
  saddlebrown500: {
    name: 'saddlebrown500',
    color: '#c86642'
  },
  saddlebrown600: {
    name: 'saddlebrown600',
    color: '#a85030'
  },
  teal100: {
    name: 'teal100',
    color: '#f0fbfc'
  },
  teal200: {
    name: 'teal200',
    color: '#e0f6f8'
  },
  teal500: {
    name: 'teal500',
    color: '#0da4ac'
  },
  teal600: {
    name: 'teal600',
    color: '#048d95'
  },
  white: {
    name: 'white',
    color: '#ffffff'
  },
  whitealpha10: {
    name: 'whitealpha10',
    color: 'rgba(#ffffff, 0.10)'
  },
  whitealpha15: {
    name: 'whitealpha15',
    color: 'rgba(#ffffff, 0.15)'
  },
  whitealpha20: {
    name: 'whitealpha20',
    color: 'rgba(#ffffff, 0.20)'
  },
  whitealpha50: {
    name: 'whitealpha50',
    color: 'rgba(#ffffff, 0.50)'
  },
  whitealpha60: {
    name: 'whitealpha60',
    color: 'rgba(#ffffff, 0.60)'
  },
  whitealpha70: {
    name: 'whitealpha70',
    color: 'rgba(#ffffff, 0.70)'
  },
  yellow100: {
    name: 'yellow100',
    color: '#fffaee'
  },
  yellow200: {
    name: 'yellow200',
    color: '#fff4d7'
  },
  yellow500: {
    name: 'yellow500',
    color: '#fac744'
  },
  yellow600: {
    name: 'yellow600',
    color: '#f0b10e'
  }
};

export { COLOR as default };
